<template>
<section>
  <!-- <pre>{{booksArray}}</pre> -->
   <Heading v-if="!usingFallback"
            :heading = "heading"
            :subheading = "subheading"
            :anchor = "anchor"
        />
    <Heading v-if="usingFallback"
        :heading = "headingFallback"
        :subheading = "subheadingFallback"
        :anchor = "anchor"
    />
        
        
        <div class="spacer" style="height:50px"></div>
 
  <div class="columns is-multiline is-variable is-3-desktop " :class="myBooksArray.length < 4 ? 'is-centered' : ''">
        <Book  
            v-for="book in (num ? myBooksArray.slice(0,num) : myBooksArray)"
            v-bind:key = book.id
            :bookObj="book"
            :isMinimal="isMinimal"
            />
        </div>
        <router-link to="/books/" class="button is-size-4 is-size-5-mobile is-info" style="margin-top:10px;">See all books</router-link>
        <div class="spacer" style="height:30px"></div>
        <p class="is-size-7 is-size-7-mobile">Some book links are affiliate links, which means BikeSleepBike may earn a small commission at no extra cost to you if you buy something through them.
                The money helps pay for hosting and infrastructure costs of running this website. As an Amazon Associate this site earns from qualifying purchases. Thanks!

            </p>

   
  </section>
</template>

<script>
import Book from '@/components/Book';
import Heading from '@/components/Heading';
export default {
  name: 'BooksList',
  components: {Book, Heading},
  props: ['booksArray', 'num', 'isMinimal', 'property', 'operator', 'value', 'propertyFallback', 'operatorFallback', 'valueFallback', 'heading', 'subheading', 'headingFallback', 'subheadingFallback', 'anchor'],
  data () {
    return {
      myBooksArray: this.booksArray ? this.booksArray : [],
      usingFallback: false,
    }
  },
  methods: {
    fetchBooks(prop, op, val) {
          if (this.$debug) {console.log("DEBUG: In function fetchBooks");}
        
        // if (value != "") { // GET FILTERED
            this.$analytics.logEvent('fetch_books', { type: 'books by ', value: prop});
            var that = this;
            var result = [];
            var query = "";
           
            if (prop && op && val) {
              query = this.$db.collection("books").where(prop, op, val);
            } else {
              query = this.$db.collection("books");
            }
            query.orderBy("title", "asc").limit(this.num).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        result.push(dataAndId);
                    
                    });
                    // console.log(result);
                    
                    if (result.length == 0 && !that.usingFallback) {
                      that.fetchBooks(that.propertyFallback, that.operatorFallback, that.valueFallback);
                      that.usingFallback = true;
                    } else {
                      that.myBooksArray = result;
                    }
                    
                    // that.isLoading = false;
                })
                .catch(function(error) {
                    console.log("Error getting books: ", error);
                    if (!that.usingFallback) {
                      that.fetchBooks(that.propertyFallback, that.operatorFallback, that.valueFallback);
                      that.usingFallback = true;
                    }
                    // that.isLoading = false;
                });
        // } 
        },
  },
  mounted() {
    if (!this.booksArray) {
      this.fetchBooks(this.property, this.operator, this.value);
    }
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 
</style>


// WEBPACK FOOTER //
// src/components/BooksList.vue